import React from 'react'

import MegaMenuItem from './MegaMenuItem'

import { SubMenuType } from '@contracts/wp/megaMenu'

import * as styles from './Submenu.module.scss'

type Props = {
	data: SubMenuType
	isOpen: boolean
	className?: string
}

const Submenu: React.FC<Props> = ({ data, isOpen, className }) => {
	const submenuStyles = [styles.submenu]

	if (isOpen) {
		submenuStyles.push(styles.isOpen)
	}

	if (className) {
		submenuStyles.push(className)
	}

	return (
		<ul className={submenuStyles.join(' ')}>
			{data.map(({ megaMenuItem }, i) => {
				return (
					<li key={i} className={styles.submenuItem}>
						<MegaMenuItem data={megaMenuItem} className={styles.megaMenuItem} />
					</li>
				)
			})}
		</ul>
	)
}

export default Submenu
